import { importProvidersFrom } from "@angular/core";
import { Routes } from "@angular/router";
import { AuthenticationGuard, AuthorizationGuard } from "@softline/auth";
import {
  SOFTLINE_SERVICE_HTTP,
  SOFTLINE_STORE_REMOTE_OBJECT_SERVICE,
  SoftlineObjectService,
  StoreModule
} from "@softline/core";
import { SOFTLINE_FEATURE_UPLOAD_ARCHIVE_VOUCHER } from "./archivbeleg-upload.shared";
import { UploadArchiveVoucherStore } from "./store/voucher.store";
import { SOFLINE_API_VOUCHER_SCAN } from "./archivbeleg-upload.api";

export const archivbelegUploadRoutes: Routes = [
  {
    path: 'archivbeleg',
    children: [
      {
        path: 'upload',
        loadComponent: () =>
          import('./pages/upload-picture/upload-picture.component').then(
            (o) => o.UploadPictureComponent
          ),
      },
      {
        path: '',
        loadComponent: () =>
          import('./pages/find-voucher/find-voucher.component').then(
            (o) => o.FindVoucherComponent
          ),
      },
      { path: '**', redirectTo: '' },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    //types: {permission: SOFTLINE_PERMISSION_UPLOAD_ARCHIVE_VOUCHER},
    providers: [
      importProvidersFrom(
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_UPLOAD_ARCHIVE_VOUCHER,
          feature: UploadArchiveVoucherStore.feature,
          providers: [
            {
              provide: SOFTLINE_STORE_REMOTE_OBJECT_SERVICE,
              useFactory: (service: any) =>
                new SoftlineObjectService(service, SOFLINE_API_VOUCHER_SCAN),
              deps: [SOFTLINE_SERVICE_HTTP],
            },
          ],
        })
      ),
    ],
  },
];
